import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "col-auto q-mr-sm"
}
const _hoisted_2 = {
  class: "col row",
  style: {"height":"100%"}
}
const _hoisted_3 = { class: "col-xs-12 title q-mb-md" }
const _hoisted_4 = { class: "col-xs-12 description q-mb-xl" }
const _hoisted_5 = {
  key: 0,
  class: "col-xs-12 self-end"
}
const _hoisted_6 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_img = _resolveComponent("q-img")!
  const _component_s_btn = _resolveComponent("s-btn")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["useful-links__item-card row items-start", { 'service__item-card--mobile': _ctx.isMobile }]),
    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goToLink && _ctx.goToLink(...args)))
  }, [
    (_ctx.hasLogo)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_q_img, {
            src: _ctx.getLogo(),
            width: "51px",
            height: "51px"
          }, null, 8, ["src"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.getLinkName), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.getLinkShortDescription), 1),
      (_ctx.hasLinks)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("a", {
              class: "s-link",
              href: _ctx.getLink?.link,
              target: "_blank",
              rel: "noopener noreferrer",
              onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
            }, _toDisplayString(_ctx.getLink?.label), 9, _hoisted_6)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_s_btn, {
      class: "useful-links__item-btn s-btn--icon__service",
      type: "icon",
      icon: "app:arrow-normal-right"
    })
  ], 2)), [
    [_vShow, !_ctx.isLoading]
  ])
}